import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Box, Link } from 'roo-ui/components';
import { scrollTop } from 'lib/browser';
import noop from 'lodash/noop';

const NextLink = ({ page, pathname, currentQuery, pageSize, total, onClick }) => {
  const newQuery = { ...currentQuery, page: page + 1 };
  const offset = page * pageSize - pageSize;
  const showLink = offset + pageSize < total;
  const linkTo = { pathname, search: queryString.stringify(newQuery) };

  const handleOnClick = () => {
    onClick(newQuery.page);
    scrollTop();
  };

  return (
    <Box>
      {showLink && (
        <Link underline as={RouterLink} to={linkTo} color="greys.charcoal" px={3} py={1} data-testid="next-link" onClick={handleOnClick}>
          Next
        </Link>
      )}
    </Box>
  );
};

NextLink.propTypes = {
  page: PropTypes.number.isRequired,
  pathname: PropTypes.string.isRequired,
  currentQuery: PropTypes.shape({}).isRequired,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

NextLink.defaultProps = {
  onClick: noop,
};

export default NextLink;
